import { rootApi } from "../../api/rootApi";

export const scratchRewardHistoryApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    // fetchAllPurchaseOrders: builder.mutation({
    //   query: (params) => {
    //     return {
    //       method: "GET",
    //       url: `/tenant/purchaseOrder`,
    //       headers: {
    //         "Content-Type": "application/json",
    //         Authorization: "Bearer " + params.token,
    //         slug: params.tenant_id,
    //       },
    //       body: params.body,
    //     };
    //   },
    // }),

    getScratchedRewardsOfOrder: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: `/tenant/scratchableRewardHistory/order/${params.order_id}?limit=${params.limit}&&offset=${params.offset}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),
  }),
});

export const {
  useGetScratchedRewardsOfOrderMutation
} = scratchRewardHistoryApi;
